import React, { useState } from 'react';
import './ConditionPopup.css';
import {useTranslation} from "react-i18next";

const ConditionPopup = ({ title,  onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    const text = "გთხოვთ, გაეცნოთ ქვემოთ მოცემულ წესებს და პირობებს. იმ შემთხვევაში, თუ გაეცანით და ეთანხმებით წესებს, გთხოვთ დააჭიროთ ღილაკს: \"ვეთანხმები პირობებს\". ღილაკზე დაჭერის შემთხვევაში თქვენი რეგისტრაცია დასრულდება.\n" +
        "\n" +
        "აღნიშნული შეთანხმება ადგენს მომხმარებლის მიერ საქართველოს ეკონომიკისა და მდგრადი განვითარების სამინისტროს სსიპ - ტექნიკური და სამშენებლო ზედამხედველობის სააგენტოს (შემდგომში სააგენტო) ელექტრონული სერვისის გამოყენების შესაძლებლობების მიღების წესსა და პირობებს. აღნიშნულის სერვისი იძლევა საშუალებას მომხმარებელმა სახლიდან ან/და ოფისიდან გაუსვლელად ელექტრონულად წარადგინოს განაცხადი სააგენტოში და მიიღოს შესაბამისი მომსახურეობა.\n" +
        "\n" +
        "საიტის ადმინისტრატორი უფლებამოსილია შეზღუდოს კონკრეტული \"სახელი\"-ს და \"პაროლი\"-ს გამოყენება იმ შემთხვევაში თუ მომხმარებლის მიერ ელექტრონული ფორმით გაკეთებული განაცხადი შეიცავს შეურაცხმყოფელ, მუქარის შემცველ გამონათქვამებს, ინფორმაციას და განცხადებებს, რომელიც ეწინააღმდეგება საქართველოს კანონმდებლობას და საჯარო წესრიგს. მომხმარებელი ვალდებულია დაუყოვნებლივ აცნობოს პორტალის ადმინისტრაციას მისი \"სახელი\"-ს და \"პაროლი\"-ს დაზიანების ან/და არასანქცირებული გამოყენების თაობაზე.\n" +
        "\n" +
        "მომხმარებლის მიერ ელექტრონული სერვისის განზრახ დაზიანების, პორტალის ნორმალური ფუნქციონირების შეზღუდვის ან შეზღუდვის მცდელობის შემთხვევაში პასუხისმგებლობა განისაზღვრება მოქმედი კანონმდებლობის შესაბამისად.\n" +
        "\n" +
        "მომხმარებლის მიერ ელექტრონული ფორმით სააგენტოსთვის გადაგზავნილი განაცხადი წარმოადგენს ადმინისტრაციული წარმოების (საქმისწარმოების) დაწყების საფუძველს.\n" +
        "\n" +
        "გადაგზავნილი განაცხადი განიხილება მოქმედი კანონმდებლობით დადგენილი წესით.\n" +
        "\n" +
        "სააგენტოს მიერ მიღებული გადაწყვეტილება ან ინფორმაცია მომხმარებელს გადაეცემა მომხმარებლის შიდა პერსონალურ გვერდზე, მხოლოდ ელექტრონულად. ამასთანავე მიიღებს მოკლე ტექსტურ შეტყობინებას და საფოსტო გზავნილს მის მიერ მითითებულ ელექტრონულ მისამართსა და მობილურზე, რაც ჩაითვლება მის მიერ სააგენტოს გადაწყვეტილების მიღებად და გაცნობად.\n" +
        "\n" +
        "მომხმარებელი სრულად არის პასუხისმგებელი მის მიერ განაცხადში მითითებულ ფაქტებსა და გარემოებებზე. იმ შემთხვევაში, თუ განაცხადი შეიცავს კომერციულ საიდუმლოებას ან პერსონალურ მონაცემებს იგი ვალდებულია გარკვევით აღნიშნოს განაცხადში ამის შესახებ.\n" +
        "\n" +
        "მომხმარებელი ვალდებულია განაცხადში გარკვევით და ზუსტად დააფიქსიროს განსახილველი მოთხოვნა. განაცხადი შევსებული უნდა იყოს სახელმწიფო ენაზე.\n" +
        "\n" +
        "სააგენტო პასუხს არ აგებს იმ უზუსტობებისათვის, რაც გამოწვეულია მომხმარებლის მიერ ელექტრონული განაცხადის შევსებისას დაშვებული შეცდომით.\n" +
        "\n" +
        "მომხმარებლის რეგისტრაციის მონაცემების შეცვლის შემთხვევაში მომხმარებელი ვალდებულია დაუყოვნებლივ ასახოს ცვლილებები მომხმარებლის გვერდზე და განათავსოს დაზუსტებული ინფორმაცია.\n" +
        "\n" +
        "სააგენტო პასუხს არ აგებს იმ არასასურველი შედეგებისათვის, რაც შეიძლება გამოიწვიოს მომხმარებლის მიერ რეგისტრაციის მონაცემების შეცვლის შეუტყობინებლობამ.\n" +
        "\n" +
        "რეგისტრაციისას წარმოდგენილი ინფორმაციის სისწორეზე პასუხიმგებლობა ეკისრება მომხმარებელს. არასწორი მონაცემის წარმოდგენის შემთხვევაში მომხმარებელს დაეკისრება კანონმდებლობით გათვალისწინებული პასუხისმგებლობა."
    const handleClose = () => {
        setIsVisible(false);
        if (onClose) {
            onClose();
        }
    };
    const { t } = useTranslation();

    if (!isVisible) return null;

    return (
        <div className="condition-popup">
            <div className="popup-inner">
                <div className="popup-header">
                    <h2>{title}</h2>
                    <button className="close-btn" onClick={handleClose}>
                        &times;
                    </button>
                </div>
                <div className="popup-content-text">
                    {text && <div>{text}</div>}
                    <button className="close-button-popup" onClick={handleClose}>
                        {t("დახურვა")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConditionPopup;
